import { useContext } from 'react';
import { DocumentVaultContext } from './DocumentVaultProvider';

export const useDocumentVaultContext = () => {
  const context = useContext(DocumentVaultContext);

  if (context === undefined) {
    throw new Error('useDocumentVaultContext must be used within a DocumentVaultProvider');
  }

  return context;
};
